import React from 'react'
import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations/translations';

const Info = () => {
  const { language } = useLanguage();
  const t = translations[language];
  
  return (
    <div className="Info">
      <a href="#contact" className="btn btn-primary">
        {t.contactMe}
      </a>
    </div>
  );
}

export default Info